<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-user-plus"></i></div>
      <div>
        Nouvelle inscription
        <div class="page-title-subheading">Saisie d'une nouvelle inscription</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>


<div class="container py-3">
    <form #insForm="ngForm">

    <div class="card">
        <div class="card-body">
            <div #reqTop>
                <igx-stepper #stepper  [linear]="false" [orientation]="'horizontal'" (activeStepChanging)="handleActiveStepChanging($event)" >
                    <igx-step>                    
                        <span igxStepIndicator><i class="fa-solid fa-child"></i></span>
                        <p igxStepTitle>Enfant</p>
                        <div igxStepContent>
                            <h2 class="text-center fw-bold mb-3">Renseignement concernant l'enfant</h2>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class=" form-group col-12 mb-3">
                                        <label for="">Nom <span class="text-danger ml-2">(*)</span></label>
                                        <input type="text" name="lastname" class="form-control" [(ngModel)]="myRequestForm.student.lastname">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class=" form-group col-12 mb-3">
                                        <label for="">Prénom(s) <span class="text-danger ml-2">(*)</span></label>
                                        <input type="text" name="firstname" class="form-control" [(ngModel)]="myRequestForm.student.firstname">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class=" form-group col-12 mb-3">
                                        <label for="">Date de naissance <span class="text-danger ml-2">(*)</span></label>
                                        <input type="date" name="birthdate" class="form-control" [(ngModel)]="myRequestForm.student.birthdate">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class=" form-group col-12 mb-3">
                                        <label for="">Lieu de naissance <span class="text-danger ml-2">(*)</span></label>
                                        <input type="text" name="name" class="form-control" [(ngModel)]="myRequestForm.student.birthplace">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class=" form-group col-12 mb-3">
                                        <label for="">Nationalité <span class="text-danger ml-2">(*)</span></label>
                                            <ng-select name="origin"  [(ngModel)]="myRequestForm.student.origin">
                                                <ng-option *ngFor="let n of nationalList" [value]="n">{{n}}</ng-option>
                                            </ng-select>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class=" form-group col-12 mb-3">
                                        <label for="">Sexe <span class="text-danger ml-2">(*)</span></label>
                                        <select class="form-control" name="sex" [(ngModel)]="myRequestForm.student.sex" id="">
                                            <option value="Homme">Homme</option>
                                            <option value="Femme">Femme</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class=" form-group col-12 mb-3">
                                        <label for="">Langue parlée <span class="text-danger ml-2">(*)</span></label>
                                        <input type="text" name="languages" class="form-control" [(ngModel)]="myRequestForm.student.languages">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class=" form-group col-12 mb-3">
                                        <label for="">Adresse <span class="text-danger ml-2">(*)</span></label>
                                        <input type="text" name="address" class="form-control" [(ngModel)]="myRequestForm.student.address">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class=" form-group col-12 mb-3">
                                        <label for="">Email </label>
                                        <input type="text" name="email" class="form-control" [(ngModel)]="myRequestForm.student.email">
                                    </div>
                                </div>

                                <div class="col-12 ">
                                    <div class=" form-group col-12 mb-3">
                                        <label for="">Classe d'inscription <span class="text-danger ml-2">(*)</span></label>
                                        <select class="form-control" name="student.classroom"  [(ngModel)]="myRequestForm.student.classroom" (change)="loadDocuments($event)">
                                            <option selected disabled></option>
                                            <option *ngFor="let c of classrooms" [value]="c.id" >{{c.name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                
                         <div class="d-flex justify-content-between align-items-center border-top pt-3 mt-4">
                            <span></span>
                            <button type="button" class="btn btn-danger btn-sm" (click)="next()">Suivant<i class="fa-solid fa-arrow-right ms-2" aria-hidden="true"></i></button>
                         </div>
                        </div>
                     </igx-step>
                
                     <igx-step>
                        <span igxStepIndicator><i class="fa-solid fa-school"></i></span>
                        <p igxStepTitle>Scolarité</p>
                        <div igxStepContent>
                            <h2 class="text-center fw-bold mb-3">Renseignement sur la scolarité de l'enfant</h2>

                            <div class="container py-2 mb-2">
                                <table class="table table-sm">
                                    <thead>
                                        <th>#</th>
                                        <th>Etablissement</th>
                                        <th>Année académique</th>
                                        <th>Classe fréquentée</th>
                                        <th>Pays</th>
                                        <th>Système</th>
                                        <th>Action</th>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let d of myRequestForm.old_schools; let i=index">
                                            <td>{{i+1}}</td>
                                            <td>{{d.school_name}}</td>
                                            <td>{{d.academic_year}}</td>
                                            <td>{{d.classroom}}</td>
                                            <td>{{d.country}}</td>
                                            <td>{{d.system}} {{d.system_precision}}</td>
                                            <td>
                                                <button class="btn btn-sm btn-primary" (click)="openOldSchoolEdition(editContent,i)"> <i class="fa fa-edit text-white"></i> </button>
                                                <button class="btn btn-sm btn-danger" (click)="removeItem(i)"> <i class="fa fa-trash text-white"></i> </button>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                               
                            </div>
                            <div class="text-center mb-3">
                                <div (click)="add(addContent)" class="btn  btn btn-sm btn-secondary">Ajouter une donnée</div>

                            </div>

                            <div class=" form-group col-12 mb-3">
                                <label for="">Précisez si votre enfant a bénéficié d'un suivi personnalisé ou relève d'un autre dispositif scolaire spécifique (trouble de l'apprentissage ou problème de santé)</label>
                                <input type="text" name="name" class="form-control" [(ngModel)]="myRequestForm.student.observation">
                            </div>
                         <div class="d-flex justify-content-between align-items-center border-top pt-3 mt-4">
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="prev()"><i class="fa-solid fa-arrow-left me-2" aria-hidden="true"></i>Précédent</button>
                            <button type="button" class="btn btn-danger btn-sm" (click)="next()">Suivant<i class="fa-solid fa-arrow-right ms-2" aria-hidden="true"></i></button>

                         </div>
                        </div>
                     </igx-step>
                    <igx-step> 
                        <span igxStepIndicator><i class="fa-solid fa-users"></i></span>
                        <p igxStepTitle>Fratrie</p>
                       <div igxStepContent>
                        <h2 class="text-center fw-bold mb-3">Renseignement concernant les frères et soeurs</h2>

                        <div class="container py-2 mb-2">
                            <div class="container py-2 mb-2">
                                <table class="table table-sm">
                                    <thead>
                                        <th>#</th>
                                        <th>Nom et prénom(s)</th>
                                        <th>Date de naissance</th>
                                        <th>Classe actuelle</th>
                                        <th>Etablissement</th>
                                        <th>Action</th>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let d of myRequestForm.student.parent.families; let i=index">
                                            <td>{{i+1}}</td>
                                            <td>{{d.identity}}</td>
                                            <td>{{d.birthdate}}</td>
                                            <td>{{d.classroom}}</td>
                                            <td>{{d.school}}</td>
                                            <td>
                                                <button class="btn btn-sm btn-primary" (click)="openFamilyEdition(editContent2,i)"> <i class="fa fa-edit text-white"></i> </button>
                                                <button class="btn btn-sm btn-danger" (click)="removeItem2(i)"> <i class="fa fa-trash text-white"></i> </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            
                        
                        </div>
                        <div class="text-center mb-3">
                            <div (click)="add(addContent2)" class="btn  btn btn-sm btn-secondary">Ajouter une donnée</div>

                        </div>
                           
                        <div class="d-flex justify-content-between align-items-center border-top pt-3 mt-4">
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="prev()"><i class="fa-solid fa-arrow-left me-2" aria-hidden="true"></i>Précédent</button>

                            <button type="button" class="btn btn-danger btn-sm" (click)="next()">Suivant<i class="fa-solid fa-arrow-right ms-2" aria-hidden="true"></i></button>

                        </div>
                       </div>
                       </div>
                  
                    </igx-step>
                    <igx-step> 
                        <span igxStepIndicator><i class="fa-solid fa-user-group"></i></span>
                        <p igxStepTitle>Parents</p>
                   
                        <div igxStepContent>
                            <h2 class="text-center fw-bold mb-3">Renseignement concernant les parents</h2>

                            <fieldset>
                                <legend>Père</legend>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Nom <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.father_lastname" class="form-control" [(ngModel)]="myRequestForm.student.parent.father_lastname">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Prénom(s) <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.father_firstname" class="form-control" [(ngModel)]="myRequestForm.student.parent.father_firstname">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Contact <span class="text-danger ml-2">(*)</span></label>
                                            <br>
                                            <input type="tel" class="form-control" placeholder="+229 ..." name="myRequestForm.student.parent.father_phone" [(ngModel)]="myRequestForm.student.parent.father_phone">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Email <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.father_email" class="form-control" [(ngModel)]="myRequestForm.student.parent.father_email">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Profession <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.father_job" class="form-control" [(ngModel)]="myRequestForm.student.parent.father_job">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Adresse <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.father_address" class="form-control" [(ngModel)]="myRequestForm.student.parent.father_address">
                                        </div>
                                    </div>
                                </div>
                    
                            </fieldset>
                            <fieldset>
                                <legend>Mère</legend>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Nom <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.mother_lastname" class="form-control" [(ngModel)]="myRequestForm.student.parent.mother_lastname">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Prénom(s) <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.mother_firstname" class="form-control" [(ngModel)]="myRequestForm.student.parent.mother_firstname">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Contact <span class="text-danger ml-2">(*)</span></label>
                                            <br>
                                            <input type="tel" class="form-control" placeholder="+229 ..." name="myRequestForm.student.parent.mother_phone" [(ngModel)]="myRequestForm.student.parent.mother_phone">  
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Email <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.mother_email" class="form-control" [(ngModel)]="myRequestForm.student.parent.mother_email">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Profession <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.mother_job" class="form-control" [(ngModel)]="myRequestForm.student.parent.mother_job">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Adresse <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.mother_address" class="form-control" [(ngModel)]="myRequestForm.student.parent.mother_address">
                                        </div>
                                    </div>
                                </div>
                    
                            </fieldset>
                           
                         <div class="d-flex justify-content-between align-items-center border-top pt-3 mt-4">
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="prev()"><i class="fa-solid fa-arrow-left me-2" aria-hidden="true"></i>Précédent</button>

                            <button type="button" class="btn btn-danger btn-sm" (click)="next()">Suivant<i class="fa-solid fa-arrow-right ms-2" aria-hidden="true"></i></button>
                         </div>
                        </div>
                     </igx-step>
                    <igx-step> 
                        <span igxStepIndicator><i class="fa-solid fa-user-shield"></i></span>
                        <p igxStepTitle>Responsable</p>
                   
                        <div igxStepContent>
                            <h2 class="text-center fw-bold mb-3">Renseignement concernant le responsable en cas d'absence des parents</h2>

                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Nom <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.tutor_lastname" class="form-control" [(ngModel)]="myRequestForm.student.parent.tutor_lastname">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Prénom(s) <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.tutor_firstname" class="form-control" [(ngModel)]="myRequestForm.student.parent.tutor_firstname">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Contact <span class="text-danger ml-2">(*)</span></label>
                                            <br>
                                            <input type="tel" class="form-control" placeholder="+229 ..." name="myRequestForm.student.parent.tutor_phone" [(ngModel)]="myRequestForm.student.parent.tutor_phone">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Email <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.tutor_email" class="form-control" [(ngModel)]="myRequestForm.student.parent.tutor_email">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Profession <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.tutor_job" class="form-control" [(ngModel)]="myRequestForm.student.parent.tutor_job">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class=" form-group col-12 mb-3">
                                            <label for="">Adresse <span class="text-danger ml-2">(*)</span></label>
                                            <input type="text" name="myRequestForm.student.parent.tutor_address" class="form-control" [(ngModel)]="myRequestForm.student.parent.tutor_address">
                                        </div>
                                    </div>
                                </div>
                    
                           
                         <div class="d-flex justify-content-between align-items-center border-top pt-3 mt-4">
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="prev()"><i class="fa-solid fa-arrow-left me-2" aria-hidden="true"></i>Précédent</button>

                            <button type="button" class="btn btn-danger btn-sm" (click)="next()">Suivant<i class="fa-solid fa-arrow-right ms-2" aria-hidden="true"></i></button>
                         </div>
                        </div>
                     </igx-step>
                     <igx-step> 
                        <span igxStepIndicator><i class="fa-solid fa-paperclip"></i></span>
                        <p igxStepTitle>Documents</p>
                   
                        <div igxStepContent>
                            <h2 class="text-center fw-bold mb-3">Documents à joindre</h2>

                           <div class="row">
                            <div class="col-12 col-md-6" *ngFor="let f of requiredFiles; let i=index;" >
                                <div class=" p-2 bg-light mb-2 " >
                              <div class="d-flex justify-content-between" >
                                  <div>
                                      <h5 class="m-1">{{f.name}} <span class="mx-1 text-danger">*</span></h5>
                                      <ng-container *ngIf="!f.isSetted">
                                          <div class="form-group mb-3 col-lg-6 col-md-6 col-sm-12">
                                              <label for="">Fichier</label>
                                              <input type="file" #fileInp (change)="upload($event,i)" 
                                              accept="application/pdf">
                                          </div>
                                      </ng-container>
                                     
                                  </div>
                                  <div class="align-self-center">
                                      <ng-container *ngIf="f.isSetted">
                                          <div >
                                              <div class="">
                                                    <div class="d-flex justify-content-around">
                                                  <i class="fa fa-eye text-info mx-1" (click)="open(content,i)" style="cursor: pointer;"></i>
                                                  <i class="fa fa-trash text-danger  mx-1" (click)="removeFile(i)"  style="cursor: pointer;"></i> 
                                              </div>
                                              </div>
                                          </div>
                                      </ng-container>
                              
                                  </div>
                              </div>
                          </div>
                       </div>
                           </div>
                           
                         <div class="d-flex justify-content-between align-items-center border-top pt-3 mt-4">
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="prev()"><i class="fa-solid fa-arrow-left me-2" aria-hidden="true"></i>Précédent</button>

                            <button type="button" class="btn btn-danger btn-sm" (click)="next()">Suivant<i class="fa-solid fa-arrow-right ms-2" aria-hidden="true"></i></button>
                         </div>
                        </div>
                     </igx-step>
                    
                    <igx-step> 
                        <span igxStepIndicator><i class="fa-solid fa-list-check"></i></span>
                        <p igxStepTitle>Récapitulatif</p>
                       <div igxStepContent>
                            <h2 class="text-center fw-bold mb-3">Récapitulatif de votre demande</h2>

                            <fieldset>
                                <legend><h5><b>Renseignement concernant l'enfant</b></h5></legend>
                                <div class="row">
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Nom</strong></dt>
                                            <dd>{{myRequestForm.student.lastname}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Prénom(s)</strong></dt>
                                            <dd>{{myRequestForm.student.firstname}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Date de naissance</strong></dt>
                                            <dd>{{myRequestForm.student.birthdate | date:"dd-MM-yyy"}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Lieu de naissance</strong></dt>
                                            <dd>{{myRequestForm.student.birthplace}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Sex</strong></dt>
                                            <dd>{{myRequestForm.student.sex}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Langue(s) parlée(s)</strong></dt>
                                            <dd>{{myRequestForm.student.languages}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Adresse</strong></dt>
                                            <dd>{{myRequestForm.student.address}}</dd>
                                        </dl>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend>Renseignement sur la scolarité de l'enfant</legend>
                                <table class="table table-sm mb-3">
                                    <thead>
                                        <th>Année scolaire</th>
                                        <th>Classe fréquentée</th>
                                        <th>Etablissement fréquenté et pays</th>
                                        <th>Système éducatif</th>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let old of myRequestForm?.old_schools">
                                            <td>{{old?.academic_year}}</td>
                                            <td>{{old?.classroom}}</td>
                                            <td>{{old?.school_name}}  {{old?.country}}</td>
                                            <td>{{old?.system}} {{old?.system_precision}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <dl>
                                    <dt> <strong>Autre observation</strong></dt>
                                    <dd>{{myRequestForm.student.observation}}</dd>
                                </dl>
                            </fieldset>
                            <fieldset>
                                <legend>Renseignement concernant les frères et soeurs</legend>
                                <table class="table table-sm">
                                    <thead>
                                        <th>Nom et prénom(s) de l'enfant</th>
                                        <th>Date de naissance</th>
                                        <th>Classe actuelle</th>
                                        <th>Etablissement actuellement fréquenté</th>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let family of myRequestForm.student.parent.families">
                                            <td>{{family?.identity}}</td>
                                            <td>{{family?.birthdate | date:"dd-MM-yyyy"}}</td>
                                            <td>{{family?.classroom}}</td>
                                            <td>{{family?.school}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </fieldset>
                            <fieldset>
                                <legend><h5><b>Renseignement concernant les parents</b></h5></legend>
                                <h5><b>Mère</b></h5>
                                <div class="row">
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Nom</strong></dt>
                                            <dd>{{myRequestForm.student.parent.mother_lastname}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Prénom(s)</strong></dt>
                                            <dd>{{myRequestForm.student.parent.mother_firstname}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Contact</strong></dt>
                                            <dd>{{myRequestForm.student.parent.mother_phone?.internationalNumber}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Email</strong></dt>
                                            <dd>{{myRequestForm.student.parent.mother_email}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Profession</strong></dt>
                                            <dd>{{myRequestForm.student.parent.mother_job}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Adresse</strong></dt>
                                            <dd>{{myRequestForm.student.parent.mother_address}}</dd>
                                        </dl>
                                    </div>
                                </div>
                                <h5><b>Père</b></h5>
                                <div class="row">
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Nom</strong></dt>
                                            <dd>{{myRequestForm.student.parent.father_lastname}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Prénom(s)</strong></dt>
                                            <dd>{{myRequestForm.student.parent.father_firstname}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Contact</strong></dt>
                                            <dd>{{myRequestForm.student.parent.father_phone?.internationalNumber}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Email</strong></dt>
                                            <dd>{{myRequestForm.student.parent.father_email}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Profession</strong></dt>
                                            <dd>{{myRequestForm.student.parent.father_job}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Adresse</strong></dt>
                                            <dd>{{myRequestForm.student.parent.father_address}}</dd>
                                        </dl>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend><h5><b>Renseignement concernant le responsable en cas d'absence des parents</b></h5></legend>
                      
                                <div class="row">
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Nom</strong></dt>
                                            <dd>{{myRequestForm.student.parent.tutor_lastname}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Prénom(s)</strong></dt>
                                            <dd>{{myRequestForm.student.parent.tutor_firstname}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Contact</strong></dt>
                                            <dd>{{myRequestForm.student.parent.tutor_phone?.internationalNumber}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Email</strong></dt>
                                            <dd>{{myRequestForm.student.parent.tutor_email}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Profession</strong></dt>
                                            <dd>{{myRequestForm.student.parent.tutor_job}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-4 col-sm-6 col-md-4">
                                        <dl>
                                            <dt> <strong>Adresse</strong></dt>
                                            <dd>{{myRequestForm.student.parent.tutor_address}}</dd>
                                        </dl>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend><h5><b>Documents joints</b></h5></legend>
                                <table class="table table-sm">
                                    <thead>
                                        <th>#</th>
                                        <th>Libellé</th>
                                        <th>Fichier</th>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let f of requiredFiles;let i=index">
                                            <td>{{i+1}}</td>
                                            <td>{{f.name}}</td>
                                            <td class="text-center"> 
                                                <i class="fa fa-eye text-info" (click)="open(content,i)" style="cursor: pointer;"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </fieldset>
                           
                        <div class="d-flex justify-content-between align-items-center border-top pt-3 mt-4">
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="prev()"><i class="fa-solid fa-arrow-left me-2" aria-hidden="true"></i>Précédent</button>

                            <button type="button" class="btn btn-danger btn-sm" (click)="store(insForm)" [disabled]="loading"><i class="fa-solid fa-check me-2" aria-hidden="true"></i>Enregistrer l'inscription <app-loading [isVisible]="loading"></app-loading></button>
                        </div>    
                        </div>
                    </igx-step>
                </igx-stepper>
            </div>
            
        </div>
    </div>
    </form>
</div>


<ng-template #content let-offcanvas id="myCanvas">
	<div class="offcanvas-header">
		<h4 class="offcanvas-title">Visualisation du document</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <object [data]="imageSrc" type="application/pdf" width="100%" height="600px"></object>

	</div>
</ng-template>



<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="addSchool(addForm)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Renseigner les champs</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Année scolaire <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="academic_year" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Classe fréquentée <span class="text-danger ml-2">(*)</span></label>
                <ng-select name="classroom" ngModel>
                    <ng-option *ngFor="let cl of classroomsList | keyvalue" [value]="cl.value">{{cl.value}}</ng-option>
                </ng-select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Nom de l'établissement <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="school_name" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Pays <span class="text-danger ml-2">(*)</span></label>
                <ng-select name="country" ngModel id="">
                    <ng-option *ngFor="let c of countries | keyvalue" [value]="c.value">{{c.value}}</ng-option>
                </ng-select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Système éducatif <span class="text-danger ml-2">(*)</span></label>
                <select name="system" class="form-control" [(ngModel)]="system">
                    <option value="Local">Local</option>
                    <option value="Français">Français</option>
                    <option value="Autre">Autre</option>
                </select>
            </div>
            <div *ngIf="system=='Autre'" class=" form-group col-12 mb-3">
                <label for="">Précision du système éducatif <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="country" class="form-control" ngModel>
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
<ng-template #editContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="editSchool()">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Renseigner les champs</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Année scolaire <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="myRequestForm.old_schools[oldSchoolCurrentIndex].academic_year" class="form-control" [(ngModel)]="myRequestForm.old_schools[oldSchoolCurrentIndex].academic_year">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Classe fréquentée <span class="text-danger ml-2">(*)</span></label>
                <ng-select  name="myRequestForm.old_schools[oldSchoolCurrentIndex].classroom"[(ngModel)]="myRequestForm.old_schools[oldSchoolCurrentIndex].classroom">
                    <ng-option *ngFor="let cl of classroomsList | keyvalue" [value]="cl.value">{{cl.value}}</ng-option>
                </ng-select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Nom de l'établissement <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="myRequestForm.old_schools[oldSchoolCurrentIndex].school_name" class="form-control" [(ngModel)]="myRequestForm.old_schools[oldSchoolCurrentIndex].school_name">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Pays <span class="text-danger ml-2">(*)</span></label>
                <ng-select [(ngModel)]="myRequestForm.old_schools[oldSchoolCurrentIndex].country" name="myRequestForm.old_schools[oldSchoolCurrentIndex].country" id="">
                    <ng-option *ngFor="let c of countries | keyvalue" [value]="c.value">{{c.value}}</ng-option>
                </ng-select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Système éducatif <span class="text-danger ml-2">(*)</span></label>
                <select name="myRequestForm.old_schools[oldSchoolCurrentIndex].system" class="form-control" [(ngModel)]="myRequestForm.old_schools[oldSchoolCurrentIndex].system">
                    <option value="Local">Local</option>
                    <option value="Français">Français</option>
                    <option value="Autre">Autre</option>
                </select>
            </div>
            <div *ngIf="oldShcoolForm.system=='Autre'" class=" form-group col-12 mb-3">
                <label for="">Précision du système éducatif <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="myRequestForm.old_schools[oldSchoolCurrentIndex].country" class="form-control" [(ngModel)]="myRequestForm.old_schools[oldSchoolCurrentIndex].system_precision">
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>



  <ng-template #addContent2 let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="addFamily(addForm)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Renseigner les champs</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Nom et prénom(s)<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="identity" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Date de naissance <span class="text-danger ml-2">(*)</span></label>
                <input type="date" name="birthdate" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Classe actuelle <span class="text-danger ml-2">(*)</span></label>
                <ng-select  name="classroom" ngModel>
                    <ng-option *ngFor="let cl of classroomsList | keyvalue" [value]="cl.value">{{cl.value}}</ng-option>
                </ng-select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Etablissement actuellement fréquenté <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="school" class="form-control" ngModel>
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
<ng-template #editContent2 let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="editFamily()">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Renseigner les champs</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Nom et prénom(s)<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="myRequestForm.student.parent.families[familyCurrentIndex].identity" class="form-control" [(ngModel)]="myRequestForm.student.parent.families[familyCurrentIndex].identity">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Date de naissance <span class="text-danger ml-2">(*)</span></label>
                <input type="date" name="myRequestForm.student.parent.families[familyCurrentIndex].birthdate" class="form-control" [(ngModel)]="myRequestForm.student.parent.families[familyCurrentIndex].birthdate">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Classe actuelle <span class="text-danger ml-2">(*)</span></label>
                <ng-select name="myRequestForm.student.parent.families[familyCurrentIndex].classroom" [(ngModel)]="myRequestForm.student.parent.families[familyCurrentIndex].classroom">
                    <ng-option *ngFor="let cl of classroomsList | keyvalue" [value]="cl.value">{{cl.value}}</ng-option>
                </ng-select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Etablissement actuellement fréquenté <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="myRequestForm.student.parent.families[familyCurrentIndex].school" class="form-control" [(ngModel)]="myRequestForm.student.parent.families[familyCurrentIndex].school">
            </div>
            
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
